module.exports = "<div class=\"w3-display-container\">\r\n\t<div class=\"w3-display-middle\">\r\n\t\t<h1 class=\"w3-text-gray font-65\"><b>Oops!</b></h1>\r\n\t\t<p>A problem occured while contacting the server.</p>\r\n\t\t<p>Please contact your administrator.</p>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/errors/connection-failed/connection-failed.component.html
// module id = ./src/app/components/errors/connection-failed/connection-failed.component.html
// module chunks = main